import { Component } from '@angular/core';

@Component({
  selector: 'app-design-gallery',
  templateUrl: './design-gallery.component.html',
  styleUrls: ['./design-gallery.component.css'],
})
export class DesignGalleryComponent {
  columns = ['status', 'vendor', 'model', 'color', 'patient', 'invoice', 'initials'];
  rows = [
    {
      status: 'TO ORDER',
      vendor: '141',
      model: 'ALOHA',
      color: 'NORTHERN LIGHTS',
      patient: 'HERNANDEZ, JASON',
      invoice: 'M94805',
      initials: 'PO',
      hold: false,
    },
    {
      status: 'CALL FOR RX',
      vendor: 'BLAKE KUWAHARA',
      model: 'ALBERS',
      color: 'MIDNIGHT',
      patient: 'OMEGA, PENNA',
      invoice: 'M94790',
      initials: 'SV',
      hold: true,
    },
  ];
  swatches = [
    { name: 'Teal', token: '--ao-teal', light: true },
    { name: 'Teal dark', token: '--ao-teal-dark', light: false },
    { name: 'Section bar', token: '--ao-section-bar', light: false },
    { name: 'Ink', token: '--ao-ink', light: false },
    { name: 'Muted', token: '--ao-muted', light: false },
    { name: 'Line', token: '--ao-line', light: true },
    { name: 'Field', token: '--ao-field', light: true },
    { name: 'Page', token: '--ao-page', light: true },
    { name: 'Panel', token: '--ao-panel', light: true },
    { name: 'Soft', token: '--ao-soft', light: true },
    { name: 'Row alternate', token: '--ao-row-alt', light: true },
    { name: 'Note', token: '--ao-note', light: true },
    { name: 'Note strong', token: '--ao-note-strong', light: true },
    { name: 'Hold', token: '--ao-hold-bg', light: true },
    { name: 'Hold ink', token: '--ao-hold-ink', light: false },
    { name: 'Danger', token: '--ao-danger', light: false },
  ];
}
